const en = {
    nav:{ 
		service:'SERVICE INTRO',
		login: 'Log in',
		logout: 'Log out',
		enterprise: 'Enterprise User',
		person: 'Individual Users',
		business: 'ENT SEARCH',
		// forum: 'FORUM',
		// demand: 'DEMAND',
		ENTERPRISE:'ENTERPRISE EXHIBITION & SEARCH',
		agent:'AGENT',
		AGENT: 'AGENT',
		charter:'Charter',
		CHARTER:'CHARTER',
		INSURANCE:'INSURANCE',	
		insurance:'Insurance',
		logistic:'LOGISTIC',
		LOGISTIC:'LOGISTIC',
		maker:'MAKER',
		MAKER:'MAKER',
		media:'MEDIA',
		MEDIA:'MEDIA',
		owner:'Owner',
		OWNER:'OWNER',
		rbyard:'Rbyard',
		RBYARD:'RBYARD',
		SHIPMANAGEMENT:'Ship Mgmt',
		SHIPMANAGEMENT:'SHIP MGMT',	
		supplier:'Supplier',
		SUPPLIER:'SUPPLIER',
		training:'Training',
		TRAINING:'TRAINING',
		forum:'Forum',
		FORUM:'FORUM',
		demand:'Demand',
		DEMAND:'DEMAND',

		privacypolicy:'Privacy Policy',
		userterms:'Terms & Conditions',
		complaintsandsuggestions:'Complaints & Suggestions',
		contactus:'Contact us',
		copyright:'Copyright',
		AllRightsReserved:"All Rights Reserved",
		ENTERPRISEEXHIBITIONBOOTH:'ENT EXHIBITION BOOTH',

		pleaseselect:'Enterprise Category',
		counteydistrict:'Country / District',
		cityport:'City / Port',
		companyname:'Country / District',
		theproduct:'Product / Service You are Looking For',
		
		SEARCH:'SEARCH',
		ForumPost:'Forum Post',
		ForumPostEditing:'Edit Forum Post',
	
		ReleaseDemand:'Demand Post',
		ReleaseDemandEditing:'Edit Demand Post',

		LoginAccount:'Log in Account',
		Noaccountleft:'No account?',
		CreateAccount:'Create Account',
		EnterpriseUsers:'Enterprise Users',
		IndividualUsers:'Individual Users',
		Email:'Email',
		EnterEmail:'Enter Email',
		Thisisarequiredfield:'Required',
		Password:'Password',
		ForgetPassword:'Forgot Password',
		Ihavereadandagreewith:'I agree with',
		UserAgreement:'User Agreement',
		Logon:'Log in',
		MobileNo:'Telephone',
		InvitationCode:'Invitation Code',
		Alreadyhaveanaccount:'Already have an account',
		passwordmustbe:'Password ≥8 letters + numbers',
		passwordNewmustbe:'New password ≥8 letters + numbers',
		Slgnup:'Sign up',
		Code:'Send Code',
		EmailCode:'Verification Code',
		ConfirmPassword:'Confirm Password',
		Reset:'Reset',
		officialnotification:'Official Notice',
		Replytomessageboard:'Msg Board Reply',
		ComplaintsandSuggestionsResponse:'Complaint Reply',
		Notificationmessagelist:'',
		Allread:'All read',
		Official:'Official',
		View:'View',
		ComplaintsandSuggestions:'Complaints & Suggestions',
		Officialnotificationcontent:'Official Notice Content',

		ForumUsage:'Forum Usage',
		FunctionIntroduction:'Func Intro',
		ForumUsagecontent:'In 2022, ZTE entered a period of strategic surpassing. While steadily consolidating its CT business as the first curve, ZTE actively created a second growth curve for the company, including IT (including IT infrastructure such as servers and storage, as well as digital transformation businesses in the 5G industry and automotive electronics) IT (including IT infrastructure such as servers and storage, as well as digital transformation businesses in the 5G industry and automotive electronics)',
		DemandUsage:'Demand Usage',
		CompanyIntroduction:'Company Intro',
		DemandUsagecontent:'',
		MerchantDisplay:'Merchant Display',
		MerchantDisplayandEditingDiagram:'Merchant Display & Edit',
		MerchantDisplaycontent:'',

		ENTERPRISEHOMEPAGEEDITING:'Ent Homepage',
		ENTONEHOMEPAGEEDITING:'Ind Homepage',
		ENTERPRIPAGEEDITING:'Edit Enterprise Homepage',
		IndividualUserHomepageEditing:'Edit Individual Homepage',
		Contact:'Contact',
		Collect:'Collect',
		UploadCompanybrochure:'Upload Brochure',
		OfficialWebsite:'Official Website',
		CompanyIntroduction:'Company Intro',
		BusinessKeywordEntry:'Business Keywords',
		ProductServiceIntroduction:'Product/Service Introduction',
		ProductServiceIntroductionPerson:'Personal Career Intro',
		UploadcompanyRegistryfile:'Upload Registry File',
		// Uploadyourresume:'Upload your resume',
		Uploadyourresume:'Upload personal CV',
		personalCV:'personal CV',
		Name:'Name',
		phonenumber:'Phone Number',
		Email:'Email',
		Save:'Save',
		Preview:'Preview',
		quitPreview:'Quit Preview',
		ConfirmDisplay:'Confirm Display',
		ReturntoEdit:'Return to Edit',

		copylink:'Copy Link',
		Collection:'Collect',
		Comment:'Comment',
		Pleaseenteryourcomment:'Enter your comment',
		Picture:'Picture',
		Cancel:'Cancel',
		confirm:'Confirm',

		MessageDetails:'Msg Details',
		
		prompt:'Prompt',
		Doyouwanttologout:'Logout?',
		WhetherToCloseTheAccount:'Close account? (All data deleted)',

		EditHomePageI:'Edit I. Homepage',
		EditHomePageE:'Edit E. Homepage',
		MyPosts:'Forum Post',
		MyDemand:'Demand Post',
		Collection:'Collect',
		Like:'Like',
		Drafts:'Drafts',
		EnterpriseAccount:'Enterprise Account',
		InvoiceApplication:'Invoice Apply',
		ForumPosts:'Forum Posts',
		RequestPosts:'Demand posts',
		UserName:'User Name',
		CompnayName:'Compnay Name',
		AccountNumber:'Account No',
		ContactAddress:'Contact Address',
		Submit:'Submit',

		FORUMPOSTEDITING:'EDIT POST',
		BothEnglishandChinesePost:'EN + CN Post',
		OnlyEnglishPost:'EN Only',
		OnlyChinesePost:'CN Only',
		EnglishPost:'English Post',
		Title:'Title',
		ForumPostKeyword:'Forum Keywords',
		DaemandPostKeyword:'Demand Keywords',
		DaemandVesselType:'Vessel Type',
		DaemandCargoType:'Cargo Type',
		DaemandShareType:'What you Demand',
		AddPicture:'Cover Picture',
		Usemultiplekeywords:'Use ; to split keywords, e.g.: 1;2;3;',
		ChinesePost:'Chinese Post',
		SaveDraft:'Save Draft',

		DEMANDEDITING:'DEMAND Post',
		
		UserAgreement: 'User Agreement',


		SERVICE:'SERVICE',
		LOGISTIC:'LOGISTIC',
		MAKER:'MAKER',
		MEDIA:'MEDIA',
		OWNER:'OWNER',
		RBYARD:'R&B YARD',
		SUPPLIER:'SUPPLIER',
		TRAINING:'TRAINING',
		Forum:'Forum',
		LoginAccount:'Log in Account',
		Noaccountleft:'No account ?',
		Logon:'Log in',
		passwordmustbe:'Password ≥8 letters + numbers',
		Slgnup:'Sign up',
		Notificationmessagelist:'Msg Notice List',
		Messageboard:'Msg board',
		content:'content',

		DetailedIntroduction:"Detail Intro",
		AGENT:'AGENT',
		CHARTER:'CHARTER',
		INSURANCE:'INSURANCE',
		Leavemessage:"Leave msg",
		DearCustomer:"Leave msg, we reply ASAP.",
		Pleaseleavemessage:"Leave a msg",
		pleasefill:"Fill info below for contact.",

		YourName:"Name",
		YourEmail:"Email:(Required)",
		YourPhone:"Phone:",
		Submitthemessage:"Submit msg",

		EnglishName:"English Name",
		ChineseName:"Chinese Name",
		corporationEnglishName:"Company EN Name",
		corporationChineseName:"Company CN Name",
		address:"Address",
		Companyaddress:"Company address",
		Contact:"Contact",


		UploadcompanyRegistryfile:"Upload Registry File",
		UploadCompanybrochure:"Upload Brochure",
		companyRegistryfile:"Registry File",
		Companybrochure:"Brochure",


		OfficialWebsite:"Official Website",
		CompanyIntroductionFill:"Fill in Company Introduction",
		ADDENGLISHDESCRIPTION:"ADD EN DESC",
		ADDCHINESEDESCRIPTION:"ADD CN DESC",

		ADDENGLISHCompanyIntroduction:"Add EN Company Intro",
		ADDCHINESEDECompanyIntroduction:"Add CN Company Intro",

		BusinessKeywordEntry:"Business Keywords",
		PersonalKeywordEntry:"Personal Keywords",
		BusinessKeyword:"Business Keyword",
		PersonalKeyword:"Personal Keyword",

		Product:"Product",
		ServiceIntroduction:"SERVICE INTRO",


		userName:"Name",
		Email:"Email",
		MobileNo:"Telephone",
		Accountinformation:"Account Info",
		Myservice:"My service",
		Mywallet:"My wallet",
		Pleaseentertherechargeamount:"Please Enter Required UNI COIN Amount (Balance≤100.00)",
		balance:"balance",
		topup:"Top Up",
		Subscribe:"Subscribe",
		Transactionrecord:"Transaction",
		Invitationcode:"Invitation Code",


		changePassword:"Change Password",
		CloseAnAccount:"Close Account",
		oldpassword:"Old Password",
		newpassword:"New Password",
		confirmpassword:"Confirm Password",
		confirmNewpassword:"Confirm New Password",

		YourAccountincreaseshared:'Your Account will get 1 UNI COIN by 1 Successfully Registered user with your shared Invitation Code',
		GenerateInvitationCode:'Generate Invitation Code',
		CopywithWebURL:'Copy Web URL',
		searchwhatyouareinterestedin:'Search What You Are Interested in',

		Tradingdate:"Trade date",
		OrderNo:"Order No",
		Service:"Service",
		Amount:"Amount",
		InvoiceapplicationCombined:"Invoice Apply",

		Applyforbilling:"Apply billing",
		ApplyBillingApplied:"Billing Applied",
		Confirmationbilling:"Confirm billing",
		Servicetype:"Service Type",
		Timeperiod:"Service period",
		season:"Seasonly ",
		year:"Yearly",
		month:"Monthly ",

		Amountpaid:"Top up Amount",
		Selectpaymentmethod:"Select pay method",
		Pleaseentertherechargeamount:"Please Enter Required UNI COIN Amount (Balance≤100.00)",
		Pleaseselectarechargemethod:"Select recharge method",
		Rechargesuccessfully:"Recharge success",
		Rechargefailed:"Recharge failed",
		Pleaseenteryourbillingemail:"Enter billing email",
		Pleaseenteryourbillinginformation:"Enter billing info",
		BillingInfo:'Billing Info',
		Successfulbilling:"Billing success",
		Twopasswordsdonotmatch:"Password not match",
		Thepasswordmustbeatleast8characterslong:"Password ≥8 chars",
		ThepasswordmustcontainbothEnglishandnumericcharacters:"Password needs letters + numbers",
		Modifiedsuccessfully:"Modify success",
		Modificationfailed:"Modify failed",
		PassworderRrororaccountdoesnotexist:"Password or account error",
		Theinvitationcodehasbeencopiedtotheclipboard:"Invitation code copied",

		Yourtopupamountcannotexceedthebalance:"Top-up amt ≤ balance",

		Yousureyouwanttotopitup:"Confirm top-up?",
		Enterpriseboothservice:"Ent booth service",
		Rechargetype:"Ent Booth Subscribe",

		REPAIRYARD:"Repair Yard",

		Balancerecharge:"Balance recharge",

		DemandPayment:"Demand Pay",
		PersonalIntroduction:"Personal Intro",
		PersonalIntroductionFill:"Fill in Personal Introduction",

		PersonalCareerorExperienceIntroduction:"Personal Career/Skill Introduction",
		ViewAllComments:"View All Comments",

		vesseloffer:'What Type of Vessel you can offer？',
		Cargooffer:'What Type of Cargo you need Shipping ？',
		Spareoffer:'Spare you offer?',
		serviceOffer:'Service you offer?',
		Susupervioffer:'Supervision you offer?',
		Engineeoffer:'Engineering you offer?',
		demandoffer:'What you offer for demand?',


		publish:'Publish',


		Placeofloading:"Loading",
		Placeofdischarge:"Discharge",
		RequirementRelease:"Release Demand",
		Usersposttheirownneeds:"Post own needs",
		Requirementtype:"Demand type",
		Budgetscope:"Budget",
		Phone:"Phone",
		Submitrequirements:"Submit demand",
		DearCustomerpleaseofferyourvaluablesuggestionsforourfurtherimprovement:"Offer your suggestions!",
		pleasefillinthebelowinformationforsmoothcontactandcommunication:"Fill info for contact",

		Notyetopened:"Not Subscribed",
		Customerservice:"Service",
		Contactemail:"Contact email",
		Contactnumber:"Contact phone",
		LoadingLocation:"Loading Location",
		LocationNeed:"Location",
		UnloadingLocation:"Unloading Location",
		DepartureLocation:"Departure Location",
		ArrivalLocation:"Arrival Location",
		Paymentmethod:"Pay method",
		Releaserequirement:"Release demand",
		Globalcurrency:"Global currency",
		perhaps:"Perhaps",
		Englishtitle:"EN title",
		Chinesetitle:"CN title",
		Alreadyonthecurrentpage:"Current page",
		PleaseuploadthecoverimageclicktheUploadimagebutton:"Upload LOGO",
		Pleasegotothepersonalaccounttoopentheenterpriseboothservice:"Open ent booth in personal account",
		Pleaseselectapaymentmethod:"Select pay method",
		Savedraftsuccessfully:"Draft Saved",
		Releasesuccessfully:"Published Successfully",
		Paymentsuccess:"Pay success",
		Pleasefillincountryregion:"Fill country/region",
		Copiedlink:"Link copied",
		Controls:"Operation",
		USERCENTER:"USER CENTER",
		HOMEPAGE:"HOME PAGE",
		Pleasechooseacategory:"Select category",

		CorporateBoothServicemon:"Enterprise Exhibition Booth Subscription",
		CorporateBoothServiceQua:"Ent Booth (Quarter)",
		CorporateBoothServiceYea:"Ent Booth (Year)",


		Thetotalamountafterrechargecannot:'Recharge: 1-100 UNI_COIN',

		EnterOneUsername:"Enter Username",
		EnterOneEmail:"Enter Email",
		EnterOnePassword:"Enter Password",
		Pleaseenterthecorrectpassword:"Enter Correct Password",
		Pleasereadtheuseragreement:"Read user agreement",
		Registrationsuccessful:"Register success",
		Sendsuccessfully:"Send success",
		EnterEmailCode:"Enter Email Code",
		EnterOneConfirmPassword:"Enter Confirm Password",
		Twopasswordsareinconsistent:"Password not match",
		Resetsuccessful:"Reset success",
		Loginsuccessful:"Login success",
		HideMyHomepage:"Hide My Homepage",
		NotAvailable:"Homepage Unavailable",
		UserHomepageHidden:"Homepage Hidden",
		Pleaseenterthename:"Enter Name",
		Pleaseselectacountry:"Select country",
		Pleaseentercompanyprofile:"Enter profile",
		Pleaseenterthewebsite:"Enter website",
		PleaseentertheEnglishname:"Enter EN name",
		PleaseentertheChinesename:"Enter CN name",

		serviceintro:"SERVICE INTRO",
		Useragreement:"User Agreement",
		tremsandconditions:"Terms & Conditions",


		YouarenotloggedinGotologin:"Not logged in, go login",
		Operationsuccessful:"Operation Successful",
		Pleaseenterthecommentcontent:"Enter comment",
		Commentsuccessful:"Comment success",
		Jumpfailed:"Jump failed",
		Copysuccessfully:"Copy success",
		Exitsuccessfully:"Exit success",
		Pleaseenterthecorrectemailaddress:"Enter valid email",
		PleaseenterthecorrectoneMobileNo:"Enter valid Mobile",
		EnterMessage:"Enter Msg",
		EnterPhoneNumber:"Enter Phone No.",
		Messageboardbackgroundreplycontent:"Msg Board Official Reply",
		Complaintsandsuggestionsbackgroundreplycontent:"Complaint Official Reply",
		Alreadyinthecurrentpage:"Current page",
		Thecurrentuserisnoteditingthehomepage:'Not editing homepage',
		Queryfailure:"Query failed",
		Pleasechangeyourpaymentmethod: "Change pay method",

		Thebalanceisinsufficientpleaserechargefirst:"Insufficient balance, recharge first",
		Applicationfailed:"Apply failed",
		SignOUTsuccessful:"Account Closed Successfully",
		EnterCompnayName:"Enter Compnay Name",
		EnterAccountNumber:"Enter Account No",
		EnterUserName:"Enter Username",
		EnterMobileNo:"Enter Mobile",
		EnterContactAddress:"Enter Contact Address",
		Areyousureyouwanttodeleteit: "Confirm delete?",
		Deletesuccessful:"Deleted Successfully",
		Deletionfailed:"Delete failed",
		cancelled:"cancelled",
		Paymentamount:"Pay amount",
		Changesuccessfully:"Change success",
		EnterTitle:"Enter Title",
		EnterKeyword:"Enter Keyword",
		Requestexception:"Request error",
		EnterContent:"Enter Content",
		Pleaseuploadpictures: "Upload pictures",
		Coverpicture:"Cover pic",
		UNICOINS:"UNI COIN",
		Pleaseenterthephonenumber:"Enter phone No.",
		Enterprisesearch:"Ent Search",
		Confirmexit:"Confirm exit",
		DemandPostReleaseCost:"Demand Post Cost",
		unicoinHk:"UNI COIN or HKD",

		IsemptyPleaseloginagain: "Empty! Login again",
		Uploadfilesizeless: "File <35MB",
		Thiscontentmayinvolvesensitiveinformation: "Content may be sensitive",
		paginationTotal: 'Total items',
		vide_title:'Video submitted. After AI check, it will show in video section',
		Pleaseuploadthevideo:'Upload video',
		SelectVideo: 'Select Video',
		VideoIntroduction :'Video Intro',
		Pleaseenterthevideointroduction:'Enter video intro',
		Videokeywords:'Video keywords',
		video:'video',
		
		noData:'No Data',
		Back:'Back',
		IntroductionEnglish:'English Introduction',
		IntroductionChinese:'Chinese Introduction',
		EnterpriseCategory:'Enterprise Category',
		CountryDistrict:'Country / District',
		CityServicePort:'City / Service Port',
		MainProductsServices:'Main Products Services',
		ProductTitleEnglish:'Product Title English',
		ProductTitleChinese:'Product Title Chinese',
		DescriptionEnglish:'Description English',
		DescriptionChinese:'Description Chinese',
		TitleChinese:'Chinese Title',
		TitleEnglish:'English Title',
		PersonalSkill:'Personal Skill',
		ViewMore:'View More',
		Details:'Details',
		Add1pictureascover:'Add 1 Picture As Cover',
		Pleaseenterthetitle:'Please Enter The Title',
		Pleaseenterthekeyword:'Please Enter The keyword',
		Pleasefollowlawsandregulations:'Please Follow Laws And Regulations',
		ViewDetails:'View Details',
		OtherDemands:'Other Demands',
		HomepageLink:'Home Page Link',
		Home:'Homepage',
		UserCenter:'User Center',
		UploadImage:'Upload Image',
		NoData:'No Data',
		SubmitComment:'Submit Comment',
		AddComment:'Add Comment',
		TotalComments:'Total Comments',
		Comments:'Comments',
		Reply:'Reply',
		ReplyComment:'Reply Comment',
		Pleaseenteryourreply:'Please Enter Your Reply',
		DemandCategory:'Demand Category',
		DemandPostKeyword:'Demand Post Keywords',
		RecommendedDemands:'Recmd Demands',
		DemandVessel:'Demand Vessel',
		CityPort:'City Port',
		AllDemands:'All Demands',
		Pleaseentervesseltype:'Please Enter Vessel Type',
		DemandCommunity:'Demand',
		Refresh:'Refresh',
		DemandCargo:'Cargo Type',
		Pleaseentercargotype:'Please Enter Cargo Type',
		Location:'Location',
		DemandKeyword:'Demand Keyword',
		Pleaseenterkeyword:'Search What you are Interested in',
		ForumCommunity:'Forum',
		SearchKeyword:'Search Keyword',
		AllForumPosts:'All Forum Posts',
		VideoCategory:'Video Category',
		VideoKeyword:'Video Keyword',
		BusinessAD:'Product/Service Display',
		TechSeminar:'Tech Seminar',
		Pleaseuploadvideo:'Please Upload Video',
		VideoFormatTip:'Video Format Tip',
		VideoPublish:'Video Publish',
		VideoBrowse:'Video',
		HotSearch:'Hot Search',
		SearchYourInterest:'Search What You Are Interested in ',
		LoadMore:'Load More',
		ServiceIntroduction:'SERVICE INTRO',
		UserGuide:'User Guide',
		MessageContent:'Message Content',
		Unread:'Unread',
		Read:'Read',
		CompanyName:'Company Name',
		ServiceYouAreLookingFor:'Service You Are Looking For',
		RecommendedCategories:'Recommended Categories',
		Delete:'Delete',
		PostCategory:'Post Category',
		All:'All',
		Habout:'About',
		AboutUs:'About Us',
		HotDemands:'Hot Demands',
		Pleaseenterthepassword:'Please enter the password',
		Rememberme:'Remember me',
		RetrievePassword:'Retrieve Password',
		Pleaseentertheinvitationcode:'Please enter the invitation code',
		UserAgreement:'User Agreement',
		Uploadsuccessful:'Upload successful',
		Uploadfailed:'Upload failed',
		Uploading:'Uploading...',
		Imagecanonlybeuploadedviathetoolbar:'Please upload images via the toolbar button',
		Thereiscurrentlynocontentavailableforviewing:'There is currently no content available for viewing',
		Youarenotloggedinpleaselogin:'You are not logged in, please log in',
		Failedtoobtaindetails:'Failed to obtain details',
		Operationfailed:'Operation failed',
		Failedtopublish:'Failed to publish',
		Publishing:'Publishing...',
		Saving:'Saving...',
		Savefailed:'Save failed',
		Pleasefillinthecompleteloadingandunloadinglocations:'Please fill in the complete loading and unloading locations',
		Pleasefillinthecompletedepartureandarrivallocations:'Please fill in the complete departure and arrival locations',
		Pleasefillinthelocationinformation:'Please fill in the location information',
		Pleaseenteryourmessage:'Please Enter Content and Insert Picture',
		PleaseenterVideomessage:'Please Enter Content',
		Pleaseenteryouremail:'Please enter your email',
		Submissionsuccessful:'Submission successful',
		Submissionfailed:'Submission failed',
		Submitting:'Submitting...',
		Submissionfailedpleasetryagainlater:'Submission failed, please try again later',
		Sending:'Sending...',
		Resendinseconds:'s Resend',
		Failedtosend:'Failed to send',
		Sendingfailedpleasetryagainlater:'Sending failed, please try again later',
		Pleaseentertheverificationcode:'Please enter the verification code',
		Pleaseenteranewpassword:'Please enter a new password',
		Pleaseconfirmthenewpassword:'Please confirm the new password',
		Thepasswordsenteredtwiceareinconsistent:'The passwords entered twice are inconsistent',
		Resettinginprogress:'Resetting in progress...',
		Passwordresetsuccessful:'Password reset successful',
		Resetfailed:'Reset failed',
		Resetfailedpleasetryagainlater:'Reset failed, please try again later',
		Failedtoretrievethelist:'Failed to retrieve the list',
		Refreshsuccessful:'Refresh successful',
		Loggingin:'Logging in...',
		Loginfailed:'Login failed',
		Likesuccessful:'Like successful',
		Unlike:'Unlike',
		Linkcopied:'Link copied',
		Copyfailed:'Copy failed',
		Commentfailed:'Comment failed',
		Pleaseenterthereplycontent:'Please enter the reply content',
		Replysuccessfully:'Reply successfully',
		Replyfailed:'Reply failed',
		Pleasereadandagreetotheuseragreement:'Please read and agree to the user agreement',
		Registering:'Registering...',
		Registrationfailed:'Registration failed',
		determine:'Confirm',
		Areyousureyouwanttocancelthecollection:'Are you sure you want to cancel the collection',
		Unsubscribedsuccessfully:'Unsubscribed successfully',
		Areyousureyouwanttocancelthelike:'Are you sure you want to cancel the like',
		Unsubscribedlikesuccessfully:'Unsubscribed like successfully',
		Areyousureyouwanttodeletethedraft:'Are you sure you want to delete the draft',
		Passworderrororaccountdoesnotexist:'Password error or account does not exist',
		Thetotalamountafterrechargecannotexceed100ortherechargeamountcannotbelessthan1:'The total amount after recharge cannot exceed 100 or the recharge amount cannot be less than 1',
		Activatedsuccessfully:'Activated successfully',
		Openingfailed:'Opening failed',
		Failedtoobtainservicefee:'Failed to obtain service fee',
		Videouploadfailedpleasetryagain:'Video upload failed, please try again',
		Videouploadfailed:'Video upload failed',
		Pleaseuploadthevideo:'Please upload the video',
		WhatTypeofSpareyoucanoffer:'What Type of Spare you can offer ？',
		WhatTypeofServiceyoucanoffer:'What Type of Service you can offer ？',
		WhatTypeofSupervisionyoucanoffer:'What Type of Supervision you can offer ？',
		WhatTypeofEngineeringServiceyoucanoffer:'What Type of Engineering Service you can offer ？',
		Whatyoucanoffer:'What you can offer ？',
		ship:'ship',
		TechnologyManagement:'Technology Management',
		goods:'goods',
		FinancialManagement:'Financial Management',
		
		Popularforumposts:'Popular forum posts',
		IndividualAccount:'Individual Account',
		videosize:'Size',
		Pleaseselectavideofile:'Please select a video file',
		Maximumvideosizelimit:'Maximum video size limit',
		Pleaseentermessage:'Please enter content',
		CollectSuccessfully:'Collect Successfully',
		ViewReply:'View Reply',
		HideReply:'Hide Reply',
		Selecttime:'Select Time',
		Edit:'Edit',
		AIFiltering:'Your Published Video is being Audited Now, it Takes about 5-10Mins',
		PleaseUploadLogoPhoto:'Please Upload Logo Photo',
		IndividualHomepage:'Individual Homepage',
		EnterpriseHomepage:'Enterprise Homepage',
		Notification:'Notification',
		ExhibitionBooth:'Enterprise Exhibition Booth',
	}
}
export default en;